<template>
  <div class="promotion-page">
    <header class="promotion-page__header">
      <h1 class="promotion-page__title">
        {{ $store.state.language === 'en' ? 'Promotions' : 'ပရိုမိုးရှင်းများ' }}
      </h1>
      <p class="promotion-page__subtitle">
        {{ $store.state.language === 'en' ? 'Exclusive bonuses & rewards' : 'အထူးဘောနပ်စ်နှင့် ဆုလက်ဆောင်များ' }}
      </p>
    </header>

    <div v-if="isLoading" class="promotion-page__loading">
      <van-loading type="spinner" color="var(--text-gold)" />
    </div>

    <div v-else-if="promotions.length === 0" class="promotion-page__empty">
      <i class="fas fa-gift" aria-hidden="true"></i>
      <p>
        {{
          $store.state.language === 'en'
            ? 'No promotions available at the moment.'
            : 'လက်ရှိတွင် ပရိုမိုးရှင်းများ မရှိသေးပါ။'
        }}
      </p>
    </div>

    <div v-else class="promotion-list">
      <article
        v-for="(promotion, proIndex) in promotions"
        :key="promotion.id || proIndex"
        class="promo-card"
      >
        <div class="promo-card__accent"></div>
        <div class="promo-card__image-wrap">
          <img
            class="promo-card__image"
            :src="promotion.image"
            :alt="promotion.title"
          />
        </div>
        <div class="promo-card__footer">
          <h2 class="promo-card__title">{{ promotion.title }}</h2>
          <button
            type="button"
            class="promo-card__btn"
            @click="promotionIndex(proIndex)"
          >
            {{ $t('detail') }}
          </button>
        </div>
      </article>
    </div>

    <van-popup
      v-model="isPromoDetailOpen"
      round
      position="center"
      get-container="body"
      class="promo-detail-popup"
    >
      <template v-if="selectedPromotion !== null">
        <div class="promo-modal__accent"></div>
        <div class="promo-modal__header">
          <h2 class="promo-modal__title">{{ promotions[selectedPromotion].title }}</h2>
          <button
            type="button"
            class="promo-modal__close"
            aria-label="Close"
            @click="selectedPromotion = null"
          >
            <i class="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
        <div
          class="promo-modal__body"
          v-html="promotions[selectedPromotion].description"
        ></div>
      </template>
    </van-popup>

    <div class="page-bottom-spacer promotion-page__bottom-spacer" aria-hidden="true"></div>
  </div>
</template>
<script>
const MOCK_PROMOTIONS = [
        {
          title: 'မန်ဘာသစ်ဘောနပ်စ် 𝟐𝟎𝟎%',
          description: `📌 ဤပရိုမိုးရှင်းသည် Phoenix ၏မန်ဘာသစ်တိုင်း (𝟏) ကြိမ် ရယူနိုင်ပါသည်။ <br><br>
                        📌 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 စသွင်းပါက ဒီပရိုမိုးရှင်းကိုရယူနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 𝟏𝟎  ဆ ပြည့်မှသာငွေထုတ်နိုင်မည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x10  ] <br><br>
                        📌 အမြင့်ဆုံးထုတ်ယူနိုင်သည့် ပမာဏသည် 𝟏𝟎 ဆ ဖြစ်ပြီး ကျန်ယူနစ်များအား 𝐬𝐞𝐫𝐯𝐞𝐫 မှ အော်တိုနုတ်ယူသွားမည်ဖြစ်သည်။ <br><br>
                        ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/phoenix888/phoenix_banner_1.webp',
        },
        
        {
          title: 'နေ့စဉ်ဘောနပ်စ် 𝟑𝟎% (တစ်နေ့တစ်ကြိမ်)',
          description: `
                        
                        📌 ဤပရိုမိုးရှင်းသည် Phoenix ၏ မန်ဘာဝင်တိုင်းတစ်ရက် (𝟏) ကြိမ်ရယူနိုင်သည်။ <br><br>
                        📌 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 30,000 ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 4 ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x 𝟒  ]<br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
                        ❌❌❌ 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 မဝယ်ရ ၊ စစ်ဆေးတွေ့ရှိပါကငွေထုတ်ပေးမည်မဟုတ်ပါ။ <br><br>
                        📌 ကန့်သတ်ချက်မရှိ ငွေထုတ်ယူနိုင်ပါသည်။`,
          image: 'https://storage.googleapis.com/spacetech2/phoenix888/banner_daily_30.webp',
        },
        // {
        //   title: 'နေ့စဉ်ဘောနပ် 10% (တစ်နေ့ 2 ကြိမ်)',
        //   description: `📌 အနည်းဆုံး 5,000 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 𝟐ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် 𝐒𝐋𝐎𝐓 အတွက် 𝐅𝐫𝐞𝐞 𝐬𝐩𝐢𝐧 ဝယ်ယူနိုင်ပါသည်။ <br><br>
        //                 ❌❌❌ ကာစီနိုမှလွဲ၍အခြားဂိမ်းများအားလုံးကစားနိုင်ပါသည်။`,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_3.jpg',
        // },
        // {
        //   title: 'နေ့စဉ်ဘောနပ်စ် 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံး 𝟑,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3 ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် ရှမ်းကိုးမီး နှင့် ဘူကြီး ကစားနိုင်ပါသည်။`,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_4.jpg',
        // },
        // {
        //   title: 'SLOT သီးသန့်ပရိုမိုးရှင်း 20% (တစ်နေ့တစ်ကြိမ်)',
        //   description: `📌 အနည်းဆုံးကျပ် 3,000 စသွင်းပါက ဒီပရိုမိုးရှင်းကိုရယူနိုင်ပါသည်။ <br><br>
        //                 📌 အမြင့်ဆုံးရယူနိုင်သည့် Bonus မှာ ငွေကျပ် 60,000 ဖြစ်ပါသည်။ <br><br>
        //                 📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည် <br><br>
        //                 📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>
        //                 ✅✅✅ ဤပရိုမိုးရှင်းသည် စလော့များကိုသာ ကစားနိုင်ပါသည်။
        //                 `,
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/banner_5.jpg',
        // },
        {
          title: 'ရှူံးကြေးပြန်အမ်းငွေဘောနပ်စ် 10%',
          description: `📌 တစ်ရက်အတွင်း ရှူးထားသောငွေ၏ 10% ကိုပြန်ရယူနိုင်ပါသည် ။ <br><br>
                        📌 ရှူံးကြေးကို ည 3 နာရီမှသုံးနာရီနောက်ပိုင်းတွင် system မှ auto ပြန်အမ်းပေးပါသည် ။ <br><br>
                        📌 နိုင်ငွေ 1 ဆ ပြည့်မှသာငွေထုတ်ပေးပါမည် ။ <br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည် ။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/phoenix888/banner_loss_return.webp',
        },
        {
          title: 'သွင်းတိုင်းရ 𝟏𝟎%',
          description: `📌 အနည်းဆုံး 𝟓,𝟎𝟎𝟎 ကစသွင်းပါကဒီပရိုမိုးရှင်းရနိုင်ပါသည်။ <br><br>
                        📌 အမြင့်ဆုံးရယူနိုင်သည့် 𝐁𝐨𝐧𝐮𝐬 မှာ ငွေကျပ် 𝟑𝟎,𝟎𝟎𝟎 ဖြစ်ပါသည်။ <br><br>
                        📌 နိုင်ငွေ 3ဆ ပြည့်မှသာ ငွေထုတ်ပေးပါမည်။ [( သွင်းငွေ+ဘောနပ်စ် ) x𝟑]<br><br>
                        📌 နိုင်ငွေ ပြည့်ပြီးပါက ကန့်သတ်ချက်မရှိ ငွေပြန်လည်ထုတ်ယူနိုင်ပါသည်။ <br><br>`,
          image: 'https://storage.googleapis.com/spacetech2/phoenix888/phoenix_banner_2.webp',
        },
      ];

export default {
  data() {
    return {
      isLoading: false,
      selectedPromotion: null,
      promotions: [],
    };
  },
  mounted() {
    this.fetchPromotions();
  },
  computed: {
    isPromoDetailOpen: {
      get() {
        return this.selectedPromotion !== null;
      },
      set(open) {
        if (!open) {
          this.selectedPromotion = null;
        }
      },
    },
  },
  methods: {
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
    async fetchPromotions() {
      this.isLoading = true;
      try {
        const res = await axios.get('/promotions');
        const apiPromotions = res.data?.data ?? res.data ?? [];
        this.promotions = Array.isArray(apiPromotions) && apiPromotions.length > 0
          ? apiPromotions
          : MOCK_PROMOTIONS;
      } catch (error) {
        console.log(error);
        this.promotions = MOCK_PROMOTIONS;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.promotion-page {
  padding: 1rem 0.75rem 0;
  background: var(--bg-dark);
}

.promotion-page__bottom-spacer {
  height: calc(10rem + env(safe-area-inset-bottom, 0px));
  min-height: calc(10rem + env(safe-area-inset-bottom, 0px));
}

.promotion-page__header {
  margin-bottom: 1.25rem;
  padding: 0 0.25rem;
}

.promotion-page__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  color: var(--text-gold);
}

.promotion-page__subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.promotion-page__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
  padding: 2rem 0;
}

.promotion-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 12rem;
  padding: 2rem 1rem;
  text-align: center;
  color: var(--text-muted);
}

.promotion-page__empty i {
  font-size: 2rem;
  color: rgba(207, 167, 87, 0.45);
}

.promotion-page__empty p {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.promotion-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.promo-card {
  position: relative;
  background: linear-gradient(165deg, #1c1c1c 0%, #121212 55%, #0d0d0d 100%);
  border: 1px solid rgba(207, 167, 87, 0.3);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
}

.promo-card__accent {
  height: 3px;
  background: var(--gradient-primary);
}

.promo-card__image-wrap {
  padding: 0.5rem 0.5rem 0;
}

.promo-card__image {
  display: block;
  width: 100%;
  border-radius: 12px;
  aspect-ratio: 16 / 6;
  object-fit: cover;
}

.promo-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.6rem 0.85rem 0.75rem;
}

.promo-card__title {
  flex: 1;
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.35;
  color: var(--text-primary);
}

.promo-card__btn {
  flex-shrink: 0;
  min-width: 5.5rem;
  padding: 0.4rem 0.85rem;
  border: 1px solid rgba(207, 167, 87, 0.5);
  border-radius: 12px;
  background: transparent;
  color: var(--text-gold);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, transform 0.15s;
}

.promo-card__btn:hover {
  background: var(--gradient-primary);
  color: #1a1a1a;
  transform: translateY(-1px);
}

.promo-card__btn:active {
  transform: translateY(0);
}

/* Detail modal */
.promo-modal__accent {
  flex-shrink: 0;
  height: 3px;
  background: var(--gradient-primary);
}

.promo-modal__header {
  position: relative;
  flex-shrink: 0;
  padding: 1.15rem 3rem 0.75rem 1.25rem;
}

.promo-modal__close {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: var(--text-secondary);
  font-size: 0.85rem;
  cursor: pointer;
  z-index: 1;
  transition: background 0.15s, color 0.15s;
}

.promo-modal__close:hover {
  background: rgba(207, 167, 87, 0.2);
  color: var(--text-gold);
}

.promo-modal__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--text-gold);
  line-height: 1.35;
  word-break: break-word;
}

.promo-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0 1.25rem 1.25rem;
  font-size: 0.88rem;
  line-height: 1.65;
  color: var(--text-secondary);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.promo-modal__body::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.promo-modal__body >>> br {
  content: '';
  display: block;
  margin-bottom: 0.25rem;
}

@media (max-width: 480px) {
  .promo-modal__title {
    font-size: 1rem;
  }

  .promo-modal__body {
    font-size: 0.85rem;
  }
}
</style>

<style>
.promo-detail-popup.van-popup--center {
  display: flex;
  flex-direction: column;
  width: calc(100% - 2rem);
  max-width: 28rem;
  height: 26rem;
  max-height: calc(100dvh - 4rem - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px));
  overflow: hidden;
  padding: 0;
  background: linear-gradient(165deg, #1c1c1c 0%, #121212 100%) !important;
  border: 1px solid rgba(207, 167, 87, 0.35);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
}

@media (max-width: 480px) {
  .promo-detail-popup.van-popup--center {
    height: 24rem;
    width: calc(100% - 1.5rem);
  }
}
</style>
